import { useSubjectUpdate } from '@healthblocks-io/core'
import { isEmpty, isNil } from 'ramda'
import { useEffect, useMemo } from 'react'
import { useTheme } from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import { Padding } from '@/@bothrs-ui/web/components/layout'
import { useEdgeInsets } from '@/@bothrs-ui/web/hooks'
import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { useKinshipTypes } from '@/modules/additional-contacts/hooks/useKinshipTypes'
import { AddContactsBox } from '@/modules/onboarding/pages/additional-contact-information/components/AddContactsBox'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'

const AdditionalContactsPage = () => {
  const theme = useTheme()
  const { top } = useEdgeInsets()

  const [{ data: subjectData }] = useSubjectUpdate()

  const {
    getKinshipTypes: { execute: getKinshipTypes, value: kinshipTypes, isLoading: kinshipLoading },
  } = useKinshipTypes()

  // Template variables
  // ------------------------------------------------------------------------- /

  const additionalContacts = useMemo(() => {
    if (kinshipLoading || isEmpty(kinshipTypes) || isNil(kinshipTypes) || !subjectData?.meta.additionalContacts) {
      return []
    }

    return subjectData?.meta.additionalContacts?.map((initialContact) => {
      return {
        ...initialContact,
        healthblocksId: initialContact.healthblocksId ?? uuidv4(),
      }
    })
  }, [kinshipLoading, subjectData?.meta.additionalContacts, kinshipTypes])

  // Effects
  // ------------------------------------------------------------------------- /
  useEffect(() => {
    getKinshipTypes()
  }, [])

  // Render Methods
  // ------------------------------------------------------------------------- /
  return kinshipLoading ? (
    <AnimatedLoader />
  ) : (
    <ContentPageLayout noScroll>
      <Padding pt={theme.UI.Spacing.Space4 + top} pb={theme.UI.Spacing.Space10} style={{ height: '100%' }}>
        <AddContactsBox initialContacts={additionalContacts} kinshipTypes={kinshipTypes} />
      </Padding>
    </ContentPageLayout>
  )
}

export { AdditionalContactsPage }
